import React from "react";
import { Icon } from "./Icon";
import { IconProps } from "./types";

/**
 * An icon component configured to work as a loading indicator with an animation & icon variant aligned to the design standards
 */
export const IconLoading = ({ speed, ...restProps }: IconLoadingProps) => {
  const getAnimationDuration = () => {
    switch (speed) {
      case "slow":
        return "1s";
      case "fast":
      default:
        return "500ms";
    }
  };

  return (
    <Icon
      alt="Loading..."
      {...restProps}
      variant="circle-notch"
    >
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="rotate"
        dur={getAnimationDuration()}
        from="0 0 0"
        to="360 0 0"
        repeatCount="indefinite"
      ></animateTransform>
    </Icon>
  );
};

export type IconLoadingProps = {
  /** the speed of the spin */
  speed?: "fast" | "slow";
} & Pick<
  IconProps,
  "colour" | "size" | "alt" | "aria-roledescription" | "className" | "style"
>;
